import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { VbSnackbarService } from '@viewbid/ui';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private injector: Injector,
        private translate: TranslateService,
    ) {}

    handleError(error: any): void {
        if (error instanceof HttpErrorResponse) {
            const snackbarService: VbSnackbarService | null = this.injector.get(
                VbSnackbarService,
                null,
            );
            if (snackbarService) {
                snackbarService.error(
                    this.translate.instant('APIErrors.message'),
                );
            }
        }
    }
}
